export const adminPath = '/admin';
export const membersPath = '/members';
export const mfaPath = '/multifactor-authentication';
export const ssoPath = '/sso';
export const supportAccessPath = '/support-access';
export const customHostnamesPath = '/custom-hostnames';
export const invitesPath = '/invites';
export const contextIdsPath = '/context-ids';
export const auditLogsPath = '/audit-logs';
